export default "<!-- CONTENT-->\n<!-- <div class=\"f-column custom-container \"> -->\n  <router-outlet></router-outlet>\n<!-- </div> -->\n"